(function () {
  const sliderEl = document.querySelector(".js-media-list");

  if (!sliderEl) return;

  const subSliderEl = document.querySelector(".js-media-sublist");

  const desktopType = sliderEl.dataset?.desktopType || "slider";
  const mobileType = sliderEl.dataset?.mobileType || "true";

  if (desktopType === "thumbs_aside") {
    function swiperInit() {
      subSliderInit(true);
      sliderInit(true);
      popupSubSliderInit(true);
      popupSliderInit(true);
    }

    document.addEventListener("shopify:section:load", function () {
      swiperInit();
    });

    if (!window?.isSwiperInit) {
      swiperInit();
    }

    window.isSwiperInit = true;
  } else {
    function swiperInit() {
      subSliderInit(true);
      sliderInit(true);
    }

    function popupswiperInit() {
      popupSubSliderInit(true);
      popupSliderInit(true);
    }

    if (!sliderEl) return;

    let wasMobile = window.innerWidth < 990;

    function swiperDestroy() {
      if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
      }

      if (subSliderEl?.swiper) {
        subSliderEl.swiper.destroy(true, true);
      }
    }

    function checkSwiper() {
      const isMobile = window.innerWidth < 990;

      if (mobileType && isMobile && !window.isSwiperInit) {
        swiperInit();
        window.isSwiperInit = true;
      }

      if (!isMobile) {
        window.isSwiperInit = false;
      }

      wasMobile = isMobile;
    }

    document.addEventListener("shopify:section:load", function () {
      checkSwiper();
      popupswiperInit();
    });

    checkSwiper();

    window.addEventListener("resize", function () {
      const isMobile = window.innerWidth < 990;

      if (isMobile !== wasMobile) {
        checkSwiper();
      }

      if (!isMobile && desktopType != "thumbs_aside") {
        swiperDestroy();
      }
    });

    if (!window?.isPopSwiperInit) {
      popupswiperInit();
    }

    window.isPopSwiperInit = true;
  }
})();

/* Spring Step Shoes refreshed multi-view PDP media filtering. */
(function () {
  const pdpConfigElement = document.querySelector("[data-sss-pdp-config]");
  let pdpVendor = "";
  try {
    pdpVendor = String(
      JSON.parse(pdpConfigElement?.textContent || "{}").vendor || ""
    );
  } catch (error) {
    pdpVendor = "";
  }
  // Azura's new on-foot gallery is server ordered; don't remove/reorder it in JS.
  if (pdpVendor.trim().toLowerCase() === "azura" &&
      document.querySelector('script[data-sss-gallery-media]')?.textContent?.includes("-OF-FALL-01")) return;
  const REFRESHED_BASE_VIEW_SIGNATURE = ["05", "02", "03", "06", "07"];
  const MAX_REFRESHED_VIEWS = REFRESHED_BASE_VIEW_SIGNATURE.length;
  const TEST_MEDIA = {
    "STICH-TP": {
      path: "/products/stich-boots",
      heroNeedle: "azura-stich-taupe-new-hero",
      onFootNeedle: "azura-stich-taupe-on-foot",
    },
  };
  const AZURA_UPDATED_FAMILIES = new Set(["COOLBEANS-BGEM","ABEAUTE-BM","ADRINA-WM","CORRIGATE-GLD","BAHAMA-RBWM","BLINGITON-B","CORRIGATE-PW","BAHAMA-BM","ADRINA-BM","AMELIA-SLM","BAHAMA-RDM","ADRINA-RDM","BAHAMA-NM","BARBRA-BM","BAHAMA-WM","COOLBEANS-BM","BAHAMIAN-WM","BAHAMIAN-BM","BAHAMA-TNM","AMELIA-GLDM","ABEAUTE-SKYM","BLINGITON-BGE","CLASSICHEEL-B","ANGELICISH-STN","AGATES-TNS","BOWLUXE-BM","CLASSYLADY-MNTS","BOWLUXE-BSHM","ADULARIA-BS","ABOVEALL-BGEM","BAHAMIAN-TQM","DAZZLINDIVA-PRL","CHECKMATE-GRYM","BROIDER-NM","LOTTALUXE-BM","CLASSYLADY-RDS","BROIDER-WM","DAZZLINDIVA-B","ANGELICISH-B","AGATES-BS","ATTENTION-B","BARBRA-YM","ABEAUTE-BSHM","CHECKMATE-WM","BROIDER-CHOCM","ABOVEALL-BRM","CLASSYLADY-BS","BARBRA-WM","CLASSICHEEL-PRL","FABILOSI-CHMM","EMBODY-GLDM","EMBROIDERY-TNM","GLISTENING-PKMT","HENNA-B","KITKATCLUB-SGLDM","KATRIEL-GLDM","KNOWING-B","KNOTTED-BM","INERTIA-BM","EMBROIDERY-BM","INDIVIDUALA-B","KARMELA-BRM","HUGBUG-BM","KATRIEL-ICEM","INTOXICATE-BM","GLITTERTWINS-PW","ENDLESSLUV-BLUM","JANNETTE-BP","KITKATCLUB-BM","INTOXICATE-OWM","KNOWING-SL","LEGENDARY-B","DIANAAR-RD","KARMELA-BGEM","KAYKAY-BM","EMBROIDERY-MNTM","EILISH-BM","IMPRESSION-B","GLITTERTWINS-GLD","DELICATE-SGLD","EILISH-BLUM","DELICATE-B","FABILOSI-PWM","KUTIR-B","EMBROIDERY-ORM","EILISH-BGEM","KUTIR-BGE","LEGENDARY-BLU","FLORAROSE-GLD","EMBROIDERY-NM","ESPALLI-B","HUGBUG-TNM","FLORAROSE-BP","DELICATE-SL","JANNETTE-PWP","INDIVIDUALA-GLD","GLISTENING-BP","CRYSTALUSHUS-GLDM","DECOROUS-B","LEGENDARY-BGE","DELICATE-N","INTERWEAVED-RBW","DECOROUS-BNE","INTOXICATE-TQM","ENDLESSLUV-BM","ENDLESSLUV-BGEM","KNOTTED-BZM","DELICATE-MVE","INERTIA-WM","ESPALLI-GLD","HENNA-BGE","IMPRESSION-TNM","PRETTY-W","OCCITANIA-B","PRETTY-B","SCULPTOR-W","SCULPTOR-WM","MIRAFLORES-BM","PRISMA-W","STATURE-B","SPARKSFLY-B","SLIDEMEIN-GLD","PRETTY-BSH","OCCITANIA-W","SLIDEMEIN-SL","SCULPTOR-B","STARRY-TQ","PRETTY-MNT","PRISMA-B","STATURE-BSH","SPARKSFLY-W","MATAHUM-B","PRETIGURL-B","WISP-B","SCULPTOR-PRM","OCCITANIA-BGE","POSHCO-BGEM","POSHCO-BZM","SUGARPLUM-BLUM","SUGARPLUM-GRM","STARRY-PCH","STARRY-GLD","NANTUCKET-BGE","SPARKSFLY-BGE","ROMANTIC-B","MATAHUM-SGLD","QUERIDITA-RBW","PRETIGURL-TP","NANTUCKET-BR","PRETIGURL-GRY","SCULPTOR-BM","MATAHUM-SL","POSHCO-BM","QUERIDITA-GRYM","SEAHARBOR-BGEM","MIRAFLORES-BGEM","ROMANTIC-BGE","WISP-BSH","MUSTBELUV-GRM","SHINYCHIC-BM","MUSTBELUV-BGEM","MIRAFLORES-BLUM","SHINYCHIC-TNM","SEAHARBOR-BM","SWEETUMS-BM","SWEETUMS-BGEM","SWEETUMS-RBW","TRENDYCHIC-WM","TENKAROT-CHAM","TRIAGE-TNM","THEVINEYARD-BR","SWEETIE-PRM","TENKAROT-BM","SWEETIE-WM","TIFFANIED-BGE","TRENDYCHIC-RDM","TRIAGE-BM","TRIAGE-GRYM","THEVINEYARD-BGE","TOTHEMOON-BM","MENDIAPA-B","MAGNETIC-B","STUDETTE-BS","VLOACEOUS-BNE","VIVIENNE-B","WANDERER-DBR","BESTILMIHART-GR","BLACKENBURY-B","CELESTE-GRYS","LIVEWIRE-B","GALORE-B","ELVIRAEST-BM","LUZISH-GRMP","ANGELINITE-BGEM","NOTICEME-B","HEAVENA-B","MACHINO-B","POISE-BRM","AURAQUARTZ-GRMP","MINERALS-BRM","BABYSTEPS-NMT","DASHING-B","CHEEKYCHIC-W","ETTAJAY-GRY","WAITASEC-B","ATTENTION-GR","BELLISH-B","ANDALUSITE-B","AGUILERA-B","FABULOSA-B","AFTERALL-B","MOZZA-B","FABILOUS-SKY","GOGETTER-BP","ALLUXURE-MNT","LUCENT-B","FIREBALL-BM","CARTWHEEL-B","FANCYFUL-SL","OHMYKAY-W","WINDSOR-OL","GOGETTER-ZEB-BPM","GOGETTER-GARNI-BRM","DAZZLEY-CHAM","DIANAAR-TP","BALDWIN-CAP","QUERIDITA-GRM","TIFFANIED-B","LILSTUDETTE-TPS","ELOQUENT-BZ","ASSISI-BGE","PARDIHARDI-B","CLARETHA-WM","BELALIA-SLM","TAMAR-SKY","KAILYN-LBGEM","PLEASEGONOW-B","POSH-BMC","STICH-TP","RAZZLEDAZ-PK","SPARKS-B","SASIKA-BM","STARDUSK-B","SNOWSTORM-NM","STARSHOW-TN","ROYALREIGN-B","ROYALEE-YS","BIGTALK-RDM","ENAMOR-PK"]);
  let scheduled = false;
  let observer = null;

  function mediaCoreFromSrc(src) {
    if (!src) return "";
    try {
      const url = new URL(src, window.location.origin);
      const file = decodeURIComponent(url.pathname.split("/").pop() || "");
      const withoutExt = file.replace(/\.[a-z0-9]+$/i, "");
      return withoutExt.split("_")[0];
    } catch (error) {
      const clean = String(src).split("?")[0].split("/").pop() || "";
      return clean.replace(/\.[a-z0-9]+$/i, "").split("_")[0];
    }
  }

  function mediaFamilyFromSrc(src) {
    return mediaCoreFromSrc(src).replace(/-(?:\d{2}|ONFOOT)$/i, "").replace(/^BALDWIN-CAMP$/i, "BALDWIN-CAP");
  }

  function mediaViewFromSrc(src) {
    const match = mediaCoreFromSrc(src).match(/-(\d{2}|ONFOOT)$/i);
    return match ? match[1].toUpperCase() : "";
  }

  function selectedVariantData() {
    const picker = document.querySelector(
      ".product-section variant-selects, .product-section variant-radios"
    );
    if (!picker || picker.dataset?.variantMediaDisplay === "show_all") return null;
    const selectedVariantScript = picker.querySelector("[data-selected-variant]");
    if (!selectedVariantScript?.textContent) return null;
    try {
      return JSON.parse(selectedVariantScript.textContent);
    } catch (error) {
      return null;
    }
  }

  function mediaIdFromElement(element) {
    const raw =
      element?.dataset?.mediaId ||
      element?.dataset?.mediaModalId ||
      element?.dataset?.mediaSubId ||
      "";
    return raw ? raw.split("-").pop() : "";
  }

  function imageSrcFromElement(element) {
    const image = element?.querySelector("img");
    return image?.currentSrc || image?.src || image?.getAttribute("src") || "";
  }

  function selectedHeroElement(mediaId) {
    if (!mediaId) return null;
    const candidates = document.querySelectorAll(
      ".product-section [data-media-id], product-modal [data-media-modal-id]"
    );
    return Array.from(candidates).find(
      (element) => mediaIdFromElement(element) === String(mediaId)
    );
  }

  function normalizedFilenameFromSrc(src) {
    if (!src) return "";
    try {
      const url = new URL(src, window.location.origin);
      return decodeURIComponent(url.pathname.split("/").pop() || "").toLowerCase();
    } catch (error) {
      return (String(src).split("?")[0].split("/").pop() || "").toLowerCase();
    }
  }

  function isPreferredRefreshed01Element(element) {
    if (!element) return false;
    const image = element.querySelector("img");
    const src = imageSrcFromElement(element);
    const filename = normalizedFilenameFromSrc(src);
    const alt = image?.alt || "";
    return /\bfront view\b/i.test(alt) || /-01_[^/.]+\.[a-z0-9]+$/i.test(filename);
  }

  function refreshedGroupForContainer(container, family) {
    if (!container || !family) return [];
    const items = Array.from(container.children).filter(
      (element) => element instanceof HTMLElement
    );
    // Azura's Fall on-foot file is shared across color variants. Its filename
    // contains the style but no color code, unlike standard 01/05/02/03/06/07 views.
    // Match the *complete* style stem to avoid cross-style collisions (e.g. GOGETTER vs GOGETTER-ZEB).
    const azuraStyle = pdpVendor.trim().toLowerCase() === "azura"
      ? family.replace(/-[^-]+$/, "").toUpperCase()
      : "";
    const azuraFallOnFoot = azuraStyle
      ? items.find((element) =>
          mediaCoreFromSrc(imageSrcFromElement(element)).toUpperCase() ===
          azuraStyle + "-OF-FALL-01"
        )
      : null;

    const familyItems = items.filter((element) => {
      const src = imageSrcFromElement(element);
      return src && mediaFamilyFromSrc(src) === family;
    });

    // Classic Patrizia galleries use a complete 01-07 set. Preserve the selected
    // color family in its existing order instead of forcing the newer 5-view recipe.
    if (pdpVendor.toLowerCase() === "patrizia") return familyItems;

    // Short galleries (1–4 images in a color) are valid. Keep that color's
    // media available, rather than falling through to an unfiltered gallery.
    if (familyItems.length < MAX_REFRESHED_VIEWS) return familyItems;

    const byView = new Map();
    familyItems.forEach((element) => {
      const view = mediaViewFromSrc(imageSrcFromElement(element));
      if (!["01", "05", "02", "03", "06", "07", "ONFOOT"].includes(view)) return;

      if (view === "01") {
        const current01 = byView.get("01");
        if (!current01 || (!isPreferredRefreshed01Element(current01) && isPreferredRefreshed01Element(element))) {
          byView.set("01", element);
        }
        return;
      }

      if (!byView.has(view)) byView.set(view, element);
    });

    const base = REFRESHED_BASE_VIEW_SIGNATURE.map((view) => byView.get(view));
    if (base.some((element) => !element)) return [];

    const candidate01 = byView.get("01");
    const isKnownAzuraFamily = [...AZURA_UPDATED_FAMILIES].some(
      (known) => known.slice(0, known.lastIndexOf("-")) === family.slice(0, family.lastIndexOf("-"))
    );
    const hasUpdated01 =
      Boolean(candidate01) &&
      (isPreferredRefreshed01Element(candidate01) || (pdpVendor.toLowerCase() === "azura" && isKnownAzuraFamily));

    const standard = hasUpdated01 ? [candidate01, ...base] : base;

    // Preserve the native/updated hero as #1 and the new Fall on-foot shot as #2.
    // Include the same style-level photo in main gallery, thumbnails and modal.
    if (azuraFallOnFoot && standard.length >= 2) {
      standard.splice(1, 0, azuraFallOnFoot);
    }

    if (isKnownAzuraFamily) {
      const onFoot = byView.get("ONFOOT");
      if (onFoot && standard.length >= 2) {
        standard.splice(azuraFallOnFoot ? 2 : 1, 0, onFoot);
      }
    }

    const config = TEST_MEDIA[family];
    if (!config || !window.location.pathname.includes(config.path)) return standard;

    const hero = items.find((element) =>
      normalizedFilenameFromSrc(imageSrcFromElement(element)).includes(config.heroNeedle)
    );
    const onFoot = items.find((element) =>
      normalizedFilenameFromSrc(imageSrcFromElement(element)).includes(config.onFootNeedle)
    );
    if (!hero || !onFoot) return standard;

    return [standard[0], standard[1], hero, onFoot, ...standard.slice(2)];
  }

  function trimContainer(container, family) {
    if (!container) return false;
    const keep = refreshedGroupForContainer(container, family);
    if (!keep.length) return false;
    const keepSet = new Set(keep);
    let changed = false;

    // Short color galleries must remain reversible when a shopper changes
    // swatches: hide other colors without deleting them from the DOM.
    if (keep.length < MAX_REFRESHED_VIEWS) {
      Array.from(container.children).forEach((element) => {
        if (!(element instanceof HTMLElement)) return;
        const hidden = !keepSet.has(element);
        if (element.classList.contains('sss-other-color-media') !== hidden) {
          element.classList.toggle('sss-other-color-media', hidden);
          changed = true;
        }
        element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      });

      // Put the selected color first in every slider (main, thumbs, zoom),
      // retaining its existing within-color image order.
      keep.forEach((element, index) => {
        if (container.children[index] !== element) {
          container.insertBefore(element, container.children[index] || null);
          changed = true;
        }
      });
      return changed;
    }

    // Preserve established five-view behavior for fully refreshed styles.
    Array.from(container.children).forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      if (!keepSet.has(element)) {
        element.remove();
        changed = true;
      }
    });

    keep.forEach((element, index) => {
      if (container.children[index] !== element) {
        container.appendChild(element);
        changed = true;
      }
    });

    return changed;
  }

  function refreshSwiper(swiperElement) {
    const swiper = swiperElement?.swiper;
    if (!swiper || swiper.destroyed) return;
    swiper.update();
    if (swiper.slides?.length) swiper.slideTo(0, 0, false);
  }

  function applySelectedColorMediaFilter() {
    const variant = selectedVariantData();
    const featuredMediaId = variant?.featured_media?.id;
    if (!featuredMediaId) return;

    const hero = selectedHeroElement(featuredMediaId);
    const heroSrc = imageSrcFromElement(hero);
    // The selected color can now legitimately use an updated 01 hero. The family,
    // not a hard-coded 05 view number, determines which media should remain visible.
    if (!heroSrc) return;

    const family = mediaFamilyFromSrc(heroSrc);
    if (!family) return;

    let changed = false;

    document
      .querySelectorAll('[data-section^="product-media-"] .product__media-list')
      .forEach((list) => {
        const container = list.querySelector(":scope > .swiper-wrapper") || list;
        changed = trimContainer(container, family) || changed;
      });

    document
      .querySelectorAll('[data-section^="product-media-"] .js-media-sublist > .swiper-wrapper')
      .forEach((container) => {
        changed = trimContainer(container, family) || changed;
      });

    document
      .querySelectorAll('product-modal .js-popup-slider > .swiper-wrapper')
      .forEach((container) => {
        changed = trimContainer(container, family) || changed;
      });

    document
      .querySelectorAll('product-modal .js-popup-sublist > .swiper-wrapper')
      .forEach((container) => {
        changed = trimContainer(container, family) || changed;
      });

    if (changed) {
      document
        .querySelectorAll(
          '[data-section^="product-media-"] .swiper, product-modal .swiper'
        )
        .forEach(refreshSwiper);
    }
  }

  function scheduleFilter() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applySelectedColorMediaFilter();
    });
  }

  function startObserver() {
    if (observer) return;
    observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) => {
        if (mutation.type !== "childList" || !mutation.addedNodes.length) return false;
        const target = mutation.target;
        return (
          target instanceof Element &&
          (target.closest('[data-section^="product-media-"]') ||
            target.closest("product-modal") ||
            target.closest("variant-selects") ||
            target.closest("variant-radios"))
        );
      });
      if (relevant) scheduleFilter();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("change", (event) => {
    if (event.target?.closest?.("variant-selects, variant-radios")) {
      scheduleFilter();
      window.setTimeout(scheduleFilter, 80);
      window.setTimeout(scheduleFilter, 250);
    }
  });

  document.addEventListener("shopify:section:load", scheduleFilter);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      startObserver();
      scheduleFilter();
    });
  } else {
    startObserver();
    scheduleFilter();
  }
})();
